module.exports = __webpack_public_path__ + "static/logo-e73fc136be484ca6c9d030f9e2b3aca7.svg";